import gql from 'graphql-tag'

import { responsiveImageFragment } from '../fragments/images.js'
import { seoFragment } from '../fragments/seo.js'
import { cardCarouselFragment, centeredMediaBlockFragment, sectionFragment, slimBannerFragment, textImageBlockFragment, zoomMasonryFragment } from '../fragments/body.js'
import { heroFragment } from '../fragments/hero.js'

export const getAltaQuota = gql`
  ${responsiveImageFragment}
  ${seoFragment}
  ${heroFragment}
  ${zoomMasonryFragment}
  ${slimBannerFragment}
  ${sectionFragment}
  ${textImageBlockFragment}
  ${centeredMediaBlockFragment}
  ${cardCarouselFragment}
  query getAltaQuota($locale: SiteLocale) {
    altaQuotaPage(locale: $locale) {
      seo {
        ...SeoFragment
      }
      hero {
        ...HeroFragment
      }
      body {
        __typename
        ... on ZoomMasonryRecord {
          ...ZoomMasonryFragment
        }
        ... on SlimBannerRecord {
          ...SlimBannerFragment
        }
        ... on SectionRecord {
          ...SectionFragment
        }
        ... on TextImageBlockRecord {
          ...TextImageBlockFragment
        }
        ... on CenteredMediaBlockRecord {
          ...CenteredMediaBlockFragment
        }
        ... on CardCarouselRecord {
          ...CardCarouselFragment
        }
      }
    }
  }
`
